function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sub-nav/sub-nav-\\u5FA9\\u539F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5FA9\\u539F",
  transform: "translate(4.000000, 3.000000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.25563945,4 C12.5883573,4.0013241 17,7.08549055 17,11.0361018 C17,13.7257783 14.9292166,16.0939557 11.7589683,17.2822616 C10.9143903,17.5988353 10.0086255,17.8246193 9.06679848,17.951635 L8.66102371,18 L8.45597544,16.259932 C9.37739302,16.1644289 10.2584361,15.9594019 11.0662018,15.6566266 C13.5803653,14.7142413 15.1333333,12.9382449 15.1333333,11.0361018 C15.1333333,8.23961942 11.7939772,5.84915572 7.51831694,5.75362729 L7.25539236,5.75066214 L3,5.75066214 L3,4 L7.25563945,4 Z",
  id: "\\u8DEF\\u5F91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u4E09\\u89D2\\u5F62",
  transform: "translate(4.000000, 4.000000) rotate(-90.000000) translate(-4.000000, -4.000000) ",
  points: "4 0 8 8 0 8"
})));

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sub-nav/sub-nav-\u5FA9\u539F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.3bec1803.svg";
export { ForwardRef as ReactComponent };